import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { postAdminUserLogin } from "store/admin/user-login/actions";

const RecentlyVisited = () => {
    const { recently_visited_clients, all_client_users } = useSelector(state => ({
        recently_visited_clients: state.AdminUsers.admin_recent_visits,
        all_client_users: state.AdminUsers.admin_users,
    }));
    const [showMore, setShowMore] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();

    const onClickUserLogin = (item) => {
        if (item) {
            dispatch(postAdminUserLogin({ user: { email: item }, history: history }));
        }
        else {
            ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: "Something went wrong!" })
        }
    };

    const displayClients = showMore
        ? recently_visited_clients?.slice(0, Math.min(10, recently_visited_clients?.length))
        : recently_visited_clients?.slice(0, Math.min(5, recently_visited_clients?.length));
    return (
        <div className="sidebar-section mt-3">
            {displayClients?.length > 0 && <span className="d-flex justify-content-between align-items-center ms-4 mb-1 fw-bold">
                <span style={{ color: '#838692' }}>RECENTLY VISITED</span>
            </span>}
            <div className="d-flex flex-column">
                {displayClients?.map((item, index) => (
                    <li key={index} >
                        <a onClick={() => onClickUserLogin(item?.account_owner_email)} style={{ fontSize: '12px' }}>
                            {item?.company_name} ({item?.account_id})
                        </a>
                    </li>
                ))}
            </div>
            {recently_visited_clients?.length > 5 && (
                <span onClick={() => setShowMore(!showMore)} className="ms-4 hover-sidebar-links" style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '100' }}>
                    {showMore ? 'Show Less' : 'Show More'}
                </span>
            )}
        </div>
    );
};

export default RecentlyVisited;
